import React, { Component } from 'react'
import {Breadcrumb} from 'semantic-ui-react'
import _ from 'lodash'
import ProfileForm from '../forms/settings/Profile'

class ProfilePage extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                Update My Profile
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                    <div className="col-md-4">

                    </div>
                </div>
                <div className="row" style={{marginTop: '10px'}}>
                    <div className="col-md-4">
                        <ProfileForm />
                        </div>
                    <div className="col-md-6">

                    </div>
                </div>
            </div>
        )
    }
}

export default ProfilePage


// WEBPACK FOOTER //
// ./src/components/settings/ProfileShow.js